function isMark(leaf, type
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
) {
  return type in leaf;
}

export { isMark };
